// extracted by mini-css-extract-plugin
export default {"drivingScorePage":"DrivingScore_drivingScorePage__-WFHK","pageContent":"DrivingScore_pageContent__S89Zx"};